import { io } from 'socket.io-client';
import { config } from '@/config';
import type { SocketNamespace } from '@/enums/websocket';
import { resolveSocketOptions } from './utils';

export function getSocket(namespace: SocketNamespace) {
  return io(`${config().BRAND_INSIGHTS_WS_URL}/${namespace}`, resolveSocketOptions());
}